import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Button } from '@fe/common/components/Button'
import { LOGIN } from 'src/constants/routes'

const ConfirmEmailMessage = styled.p`
  margin-bottom: 4rem;
`

export const SuccessStep: React.FC = () => {
  const { t } = useTranslation('no-auth')

  return (
    <>
      <ConfirmEmailMessage data-test-id="confirmation_message">
        {t('confirmation-sent')}
      </ConfirmEmailMessage>

      <Button href={LOGIN} isFullWidth testId="return_to_login">
        {t('return-to-login')}
      </Button>
    </>
  )
}
